import React, { useEffect } from 'react';
import { get, set } from 'lodash';
import { Button, message, Popover, Space, Tooltip } from 'antd';
import { CopyOutlined, ShareAltOutlined } from '@ant-design/icons';
import track, { CLICK_SHARE_FROM_KEBAB } from '@src/utils/sensor/track';
import getActualShareLink from '../../common/Sharing/SharingModal/SharingContent/getActualShareLink';
import copy from 'copy-to-clipboard';
import { selectedCustomerIdSelector } from '@store/common/selectors';
import { useSelector } from 'react-redux';
import { activeDashboardSelector } from '@src/store/tempDashboard/selectors';
import { useGetShare } from '../atom';
import { LinkWrapper } from './styled';
import useCreateShareDashboard from './useCreateShareDashboard';
import { usePrevious } from 'react-use';
import { USECASE_KEY_WIDGET_DRILLDOWN } from '@utils/constants';

const PopShare = ({ config }) => {
  const customerId = useSelector(selectedCustomerIdSelector);

  // TODO: The widgetMeta is introduced to support flow preset dashboard, used to store the flow ID.
  // TODO: But now we are using usecaseKey to identify the flow preset dashboard, the flow ID is a part of the usecaseKey.
  // TODO: Should switch to pageMeta, and store widgetMeta into drilldownMeta in dashboard initialization.
  const { usecaseKey, widgetMeta }: any = useSelector(activeDashboardSelector);
  const [open, setOpen] = React.useState(false);

  const pageKey = get(config, ['page', 'key'], null);
  const { shareData } = useGetShare({ pageKey });
  const { url } = config;

  const mutation = useCreateShareDashboard();
  const id = get(mutation, ['data', 'data'], null);

  const prevShareData = usePrevious(shareData);

  const handleClick = () => {
    if (usecaseKey) {
      set(shareData, 'state.usecaseKey', usecaseKey);
    }
    if (usecaseKey === USECASE_KEY_WIDGET_DRILLDOWN) {
      set(shareData, 'state.widgetMeta', widgetMeta);
    }
    // create a new share dashboard if data changed
    if (prevShareData !== shareData) {
      mutation.mutate(shareData, {
        onSuccess: () => {
          setOpen(true);
        },
      });
    } else {
      setOpen(true);
    }
    track({ event: CLICK_SHARE_FROM_KEBAB });
  };

  const handleOpen = (triggerValue) => {
    if (open) {
      setOpen(triggerValue);
    }
  };

  return (
    <>
      <Popover
        content={<LinkPane url={url} id={id} customerId={customerId} handleOpen={handleOpen} />}
        title="Share"
        trigger="click"
        placement="bottomRight"
        open={open}
        onOpenChange={handleOpen}
        destroyOnHidden={true}
      >
        <Tooltip title="Share">
          <Button loading={mutation.isLoading} onClick={handleClick} icon={<ShareAltOutlined />} />
        </Tooltip>
      </Popover>
    </>
  );
};

export const LinkPane = ({ url, id, customerId, handleOpen }) => {
  const finalUrl = getActualShareLink(`${url}/${id}`, customerId);

  useEffect(() => {
    if (copy(finalUrl, { format: 'text/plain' })) {
      message.info('Copied to clipboard');
    }
  }, [finalUrl]);

  const handleOnCopy = () => {
    copy(finalUrl, { format: 'text/plain' });
    handleOpen(false);
  };

  return (
    <LinkWrapper>
      <Space>
        <a target="_blank" rel="noopener noreferrer" href={finalUrl}>
          {finalUrl}
        </a>
        <Button type="primary" icon={<CopyOutlined />} onClick={handleOnCopy} />
      </Space>
    </LinkWrapper>
  );
};

export default PopShare;
